"use client";

import { BreadcrumbsSlot } from "./breadcrumbs";
import { PlayerHeader, PlayerHeaderBrand } from "./player/navigation";
import { usePlayerSession } from "./player/session";

export function SiteHeader({
  current,
  hideDesktopNavigation = false,
  mobileBackHref,
  hideMobileNavigation = false,
}: {
  current:
    | "home"
    | "features"
    | "pricing"
    | "account"
    | "count-nine"
    | "bowlard"
    | "set-match"
    | "layouts"
    | "drills"
    | "tools"
    | "billing"
    | "shop"
    | "stores"
    | "players"
    | "recruitments";
  hideDesktopNavigation?: boolean;
  mobileBackHref?: string;
  hideMobileNavigation?: boolean;
}) {
  const { status } = usePlayerSession();
  if (status === "ready" || status === "loading")
    return (
      <PlayerHeader
        hideDesktopNavigation={hideDesktopNavigation}
        mobileBackHref={mobileBackHref}
        hideMobileNavigation={hideMobileNavigation}
      />
    );
  return (
    <header className="site-header app-header guest-header">
      <a className="skip-link" href="#main-content">
        本文へ移動
      </a>
      <BreadcrumbsSlot />
      <PlayerHeaderBrand guest mobileBackHref={mobileBackHref} />
      <nav aria-label="メインナビゲーション" className="app-nav">
        <a href="/" aria-current={current === "home" ? "page" : undefined}>
          ホーム
        </a>
        <a
          href="/features"
          aria-current={
            !["home", "account", "billing", "pricing"].includes(current)
              ? "page"
              : undefined
          }
        >
          機能
        </a>
        <a
          href="/pricing"
          aria-current={
            current === "pricing" || current === "billing" ? "page" : undefined
          }
        >
          料金
        </a>
        <a className="nav-login" href="/login">
          ログイン
        </a>
        <a className="nav-signup" href="/signup">
          無料で会員登録
        </a>
      </nav>
    </header>
  );
}
